// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".project-table.el-table tr th.el-table__cell,.project-table tr th{background:#f6f6f6}.project-table tr td,.project-table tr td.el-table__cell{border-bottom:none}.project-table th>.cell{font-weight:700!important;padding:0}", ""]);
// Exports
module.exports = exports;
